import { Component, OnInit, Sanitizer } from '@angular/core';
import { CleverTapConstents } from 'src/app/services/constants';
import { TosterMsgType } from 'src/app/services/model';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'app-nach-mandate',
  templateUrl: './nach-mandate.component.html',
  styleUrls: ['./nach-mandate.component.scss']
})
export class NachMandateComponent implements OnInit {


  nachVerifyPopup: boolean = false;
  mandatePopup: boolean = false;
  isAadhaarMandateFailed:boolean = false;
  get nachRECOMMENDATION () {
    if(!this.util.waitingResponse){
      return {};
    }
 return this.util.waitingResponse.find((data:any)=> data.id === 'NACH_RECOMMENDATION');
  };
  nachMandateData: any = {};
  disbursementDate: string = '';
  loanApplicants: any[] = [];
  mandateVariants: any = {};
  pNach:boolean = false;
  popupWindow: any;
  mandateOptionValue: any;
  nachData: any; 
  get selectedbank() {
    let bank: any = {};
    this.loanApplicants.forEach((res: any) => {
      res.loanBankConnectAccountsInfo.forEach((res: any) => {
        if (res.isSelected) {
          bank = res;
        }
      });
    });
    return bank;
  }
  constructor(public util: UtilService) { }

  ngOnInit(): void {
    this.init(); 
    this.util.userLoggedInEventCalled.subscribe(()=>{
      this.init(); 
    })
  }

  init(){
    const lsm = this.util.loanDetails;
    if(!lsm ){
      return;
    }

    
   
    this.loanApplicants = (lsm.loanApplicantDetails || []).filter((applicant:any)=> applicant.loanBankConnectAccountsInfo.length);
    const bankAccounts = lsm.loanBankConnectAccountsInfo || [];
    if (!bankAccounts.length) {
      this.util.showToaster('No bank account found', TosterMsgType.ERROR);
      this.util.route('home');
    }

    this.loanApplicants[0].loanBankConnectAccountsInfo[0].isSelected = true;

    this.getDisbursementDate();
     this.util.cleverTapEventCall(CleverTapConstents.Enach_mandate_initiated,{});
  }

  selectBank(bank: any) {
    this.loanApplicants.forEach((res: any) => {
      res.loanBankConnectAccountsInfo.forEach((res: any) => {
        res.isSelected = false;
      });
    });

    bank.isSelected = true;
  }

  showNachPopup() {
    this.nachVerifyPopup = true;
  }

  showMandatePopup() {
    this.mandatePopup = true;
  }

  getDisbursementDate() {
    this.util.handleRequests('get', this.util.getUrl('loan_disbursementDate')).then((res: any) => {
      if (res.content) {
        const date = res.content.disbursementDate.split('-');
        this.disbursementDate = `${date[0]}-${date[1]}-${date[2]}`;
      }
    });
  }
  getBranchName(obj: any) {
    if (obj.branch) {
      return obj
    } else {
      obj.branch = 'loading..';
      this.util.handleRequests('get', this.util.getUrl('loan_validate_ifsc', [obj.ifsc]), undefined, undefined, undefined, false).then((res: any) => {
        obj.branch = res.content?.BRANCH;

      });
    }


    return obj;
  }

  submit() {
    const account = this.selectedbank;
    this.util.show(account.name,()=>{},()=>{},false,false,'','','','','',false,true);
    this.util.handleRequests('put', this.util.getUrl('loan_primaryBankAccount'), {
      'loanId': this.util.loanDetails.loanId, 'accountId': account.accountId, 'disbursementDate': this.disbursementDate
    }, undefined,undefined,undefined,false).then((res: any) => {
      this.util.cleverTapEventCall(CleverTapConstents.Enach_mandate_completed,{
        applicantType: this.util.getCurrentApplicant.mainApplicant == true ?"Main Applicant":"Co-Applicant",
        'loanId': this.util.loanDetails.loanId, 'productCode': this.util.loanDetails.productCategory,
      });
      this.util.hide();
      const mandateVariants = res.content.mandateVariants;

      this.nachData = mandateVariants;
      this.handleMandates({ ...mandateVariants});

    }).catch(()=>{
      this.util.hide();
      this.util.cleverTapEventCall(CleverTapConstents.Enach_mandate_failed,{
        applicantType: this.util.getCurrentApplicant.mainApplicant == true ?"Main Applicant":"Co-Applicant",
        'loanId': this.util.loanDetails.loanId, 'productCode': this.util.loanDetails.productCategory,
      });
    });

  }


  handleMandates(mandateVariants: any) {
   
    this.nachMandateData = mandateVariants;
    this.mandateVariants = {};
    this.mandatePopup = true;
    // Navigatate to pNach Screen when isPhysicalNach is true
    if (mandateVariants?.isPhysicalNach) {
      this.mandateVariants = { isPhysicalNach: true };
      return;
    }

    ///Navigate to enach webview when esign is false
    if (mandateVariants?.isEsign === false) {
      this.mandateVariants = { emandate: true };
      return
    }

    ///Navigate to enach option when esign and netbank both true
    if (mandateVariants?.isEsign == true &&
      (mandateVariants?.isDebitCard == true
        || mandateVariants?.isNetBanking == true)) {
      this.mandatePopup = false;
      if (this.nachMandateData.emandateRejectCount >= 3) {
        this.mandateOptionValue = 'esign';
      this.util.cleverTapEventCall(CleverTapConstents.aadhar_mandate_initiated,{});
      }
      this.mandateVariants = { eNachOption: true };
      return;
    }

    ///Navigate to enach option when esign is true
    if (mandateVariants?.isEsign == true &&
      (mandateVariants?.isDebitCard == false
        && mandateVariants?.isNetBanking == false)) {
      this.mandateVariants = { esign: true };
      return;
    }



  }

  openEmandate() {
    if(this.mandateVariants.isPhysicalNach){
      this.openPmandate();
      return
    }
    const mandateType = this.mandateVariants.emandate ? 'emandate' : this.mandateVariants.esign ? 'esign' : ''
    this.util.handleRequests('get', this.util.getUrl('loan_nach_mandate', [this.util.loanDetails.loanId, mandateType])).then((res: any) => {
      const url = res.content;
      if(this.mandateVariants.isPhysicalNach){
        this.pNach = true; 
        this.mandatePopup = false;
         return;
      }else{
        this.popupWindow = window.open(url);

        this.util.loaderService.show();
        this.checkMandateStatus()
      }
     
    });


  }
  openPmandate(){
    const mandateType = 'pmandate';
    this.util.handleRequests('put', this.util.getUrl('loan_physicalNach_generateNachForm', [this.util.loanDetails.loanId, mandateType])).then((res: any) => {
      if(res.status == "SUCCESS"){
        this.pNach = true; 
          this.mandatePopup = false;
           return;
      }
    
     
    });
  }
  checkMandateStatus() {
    
    setTimeout(() => {
      this.util.handleRequests('put', this.util.getUrl('loan_nach_confirm'), { 'loanId': this.util.loanDetails.loanId }, undefined, undefined, undefined, false).then((res: any) => {
        this.popupWindow.self.close(); 
        this.util.loaderService.hide();
        this.util.getProducts().then(() => {
          this.util.navigationHandler();
        });
      }).catch((err: any) => {
        if (!this.popupWindow || this.popupWindow?.closed || this.popupWindow?.self?.closed) {
          this.util.showToaster(err.msg, TosterMsgType.ERROR);
          this.util.route('home');
          this.util.loaderService.hide();
        } else {
          this.checkMandateStatus();
        }

      });
    }, 2000)
  }

  submitMandate() {
    this.mandateVariants = { eNachOption: true, [this.mandateOptionValue]: true };
    this.mandatePopup = true;
  }
 
}
